import { render, staticRenderFns } from "./TenantAffiliateEdit.vue?vue&type=template&id=32d9744a&scoped=true"
import script from "./TenantAffiliateEdit.vue?vue&type=script&lang=js"
export * from "./TenantAffiliateEdit.vue?vue&type=script&lang=js"
import style0 from "./TenantAffiliateEdit.vue?vue&type=style&index=0&id=32d9744a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9744a",
  null
  
)

export default component.exports